import { TimerLockIcon } from './TimerLockIcon';

/**
 * author: Colton Wiscombe
 * id E2B4F7F7-FF17-4CCE-A1C7-BD677E2F32D5
 * name timer-lock
 * version: 6.8.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/timer-lock.svg
 * tags
 * - Date / Time 
 * - Lock 
 */
export const StopwatchSecureIcon = TimerLockIcon;
export default StopwatchSecureIcon